import React, { Component } from "react";
import './Jumbotron.css';

class Jumbotron extends Component {
  render(){
    const { title, description, children } = this.props;

    return(
      <div className='jumbotron'>
        <div className='container'>
          {title && <h1>{title}</h1>}
          {description && <p>{description}</p>}
          {children}
        </div>
      </div>
    )
  }
}

export default Jumbotron
